import styled from '@emotion/styled';
import { Box, Flex, Heading, Text } from '@rebass/emotion';
import { AppTheme } from '@app/styles/theme';
import { rem } from '@app/styles/theme/layout';

export const Wrapper = styled(Flex)<{ theme: AppTheme }>`
  border: ${rem(1)} solid ${({ theme }) => theme.colors.productBorderColor};
  padding: ${rem(25)} ${rem(25)} ${rem(15)};
  height: 100%;
  flex-direction: column;
`;

export const Title = styled(Heading)`
  font-size: ${rem(20)};
  margin-bottom: ${rem(20)};
`;

export const Picture = styled.img`
  display: block;
  margin: 0 auto ${rem(10)};
`;

export const Price = styled(Text)<{ theme: AppTheme }>`
  white-space: pre;
  font-weight: bold;
  font-size: ${rem(20)};
  font-family: ${({ theme }) => theme.fonts.fontSemi};
`;

export const FeaturesList = styled.ul<{ theme: AppTheme }>`
  padding: 0;
  li {
    position: relative;
    list-style: none;
    font-size: ${rem(14)};
    padding-left: ${rem(14)};
    padding-bottom: ${rem(5)};
    &:before {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      top: ${rem(4)};
      left: 0;
      border-top: ${rem(4)} solid transparent;
      border-left: ${rem(4)} solid ${({ theme }) => theme.colors.black};
      border-bottom: ${rem(4)} solid transparent;
    }
  }
`;

export const Content = styled(Box)<{ theme: AppTheme }>`
  ul {
    padding: 0;
    li {
      font-size: ${rem(14)};
      padding-bottom: ${rem(5)};
      position: relative;
      list-style: none;
      padding-left: ${rem(14)};
      &:before {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border-top: ${rem(4)} solid transparent;
        border-left: ${rem(4)} solid ${({ theme }) => theme.colors.black};
        border-bottom: ${rem(4)} solid transparent;
        top: ${rem(4)};
        left: 0;
      }
    }
  }

  a {
    &:hover {
      text-decoration: underline;
      color: ${({ theme }) => theme.colors.protectedContentLinkHover};
      transition: all 0.3s;
    }
  }
`;
